import generateBootFunc from '../../generate-boot';

import Index from "./Components/Index.vue";

const bootIndex = generateBootFunc(Index, 'settings-division-miscellaneous-index');

export default bootIndex